import 'glightbox/dist/css/glightbox.min.css';
import 'swiper/dist/css/swiper.css';
import '../../scss/pages/product.scss';

import {AlcoholBox} from "../libraries/alcohol-box";
import {DefaultScreenDetector} from "../libraries/screen-detector/DefaultScreenDetector";
import {DefaultProductsCarousel} from "../libraries/product-list/DefaultProductsCarousel";
import {CustomerFeedback} from "../libraries/customer-feedback/CustomerFeedback";
import {DocumentRelativeOffset} from "../libraries/document-relative-offset";
import {CartCountElement} from "../libraries/CartCountElement";
import {SecurityContainer} from "../libraries/SecurityContainer";
import store from "./../vue/store";
import hcSticky from 'hc-sticky';
import {HashRouter} from "../libraries/HashRouter";
import Swiper from 'swiper';
import Vue from "vue";
import CuttableProductPreview from "@danhoss/cuttable-product-preview-component";
import {NotifyEmailClient} from "../http-clients/NotifyEmailClient";
import {ScreenDetectorFactory} from "../libraries/screen-detector/ScreenDetectorFactory";
import GLightbox from 'glightbox';
import {EventDispatcher} from "../libraries/event-dispatcher";

import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';

defineElement(lottie.loadAnimation);

const documentRelativeOffset = new DocumentRelativeOffset();

const mobileBreakPoint = 850;
const mobileCallback = () => {
    return window.innerWidth < mobileBreakPoint && window.innerWidth < window.innerHeight;
};
const ScreenDetector = ScreenDetectorFactory.create(mobileCallback);

document.querySelectorAll('.product-description .tab-header').forEach((element) => {
    const isMobile = ScreenDetector.isMobileView();

    // setup mobile view:
    if (isMobile) {
        document.querySelectorAll('.product-description .attributes').forEach(contentElement => {
            contentElement.classList.add('hidden-section');
        });
    }

    // setup desktop view:
    document.querySelectorAll('.product-description .product-safety').forEach(contentElement => {
        contentElement.classList.add('hidden-section');
    });
    document.querySelectorAll('.product-description .manufacturers-data').forEach(contentElement => {
        contentElement.classList.add('hidden-section');
    });
    document.querySelectorAll('.product-description .payment').forEach(contentElement => {
        contentElement.classList.add('hidden-section');
    });
    document.querySelectorAll('.product-description .description').forEach(contentElement => {
        contentElement.classList.add('hidden-section');
    });

    element.addEventListener('click', (() => {
        const tabIsOpened = !element.classList.contains('hidden-section');
        if (tabIsOpened) {
            document.querySelectorAll('.product-description .attributes').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .description').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .shipping').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .payment').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .manufacturers-data').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .product-safety').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });

            return;
        }

        let attributesSectionClicked = element.classList.contains('attributes');
        let shippingSectionClicked = element.classList.contains('shipping');
        let paymentSectionClicked = element.classList.contains('payment');
        let productSafetySectionClicked = element.classList.contains('product-safety');
        let manufacturersSectionClicked = element.classList.contains('manufacturers-data');
        let descriptionSectionClicked = element.classList.contains('description');

        let sectionToShow = '';
        let sectionsToHide = [''];

        if (attributesSectionClicked) {

            sectionToShow = 'attributes';
            sectionsToHide = ['description','payment','shipping','manufacturers-data','product-safety'];

        } else if (shippingSectionClicked) {

            sectionToShow = 'shipping';
            sectionsToHide = ['description','payment','attributes','manufacturers-data','product-safety'];

        } else if (paymentSectionClicked) {

            sectionToShow = 'payment';
            sectionsToHide = ['description','shipping','attributes','manufacturers-data','product-safety'];

        } else if (descriptionSectionClicked) {

            sectionToShow = 'description';
            sectionsToHide = ['shipping','payment','attributes','manufacturers-data','product-safety'];

        } else if (manufacturersSectionClicked) {

            sectionToShow = 'manufacturers-data';
            sectionsToHide = ['shipping','payment','attributes','description','product-safety'];

        } else if (productSafetySectionClicked) {

            sectionToShow = 'product-safety';
            sectionsToHide = ['shipping','payment','attributes','description','manufacturers-data'];

        }

        document.querySelectorAll('.product-description .' + sectionToShow).forEach((element) => {
            element.classList.remove('hidden-section');
        });
        sectionsToHide.forEach((sectionToHide) => {
            document.querySelectorAll('.product-description .' + sectionToHide).forEach((element) => {
                element.classList.add('hidden-section');
            });
        })

        if (sticky) {
            setTimeout(() => {
                sticky.refresh();
            }, 0)
        }

        let offset = documentRelativeOffset.getBySelectorOffset('.product-description');
        if (window.scrollY > offset.top) {
            window.scrollTo(0, 0.9 * offset.top);
        }

        initDetailsProductsHeight();
    }))
});

function initializeWishListToggleButton() {
    const currentProductId = CURRENT_PRODUCT_ID;
    const wishListToggleButtons = document.querySelectorAll('.wish-list-toggle-product');

    /**
     * @param productId
     * @return {boolean}
     */
    const productInWishList = productId => {
        const wishListProducts = store.getters['wishList/products'];
        const productModel = wishListProducts.find(model => model.id === productId);

        return !!productModel;
    };

    store.subscribe(mutation => {
        const mutationType = mutation.type;
        const mutationPayload = mutation.payload;

        switch (mutationType) {
            // Render icon when wish list will be fetch
            case 'wishList/setLoading':
                if (false === mutationPayload) {
                    const checked = productInWishList(currentProductId);

                    if (checked) {
                        wishListToggleButtons.forEach(button => {
                            const icon = button.querySelector('.icon');

                            icon.classList.remove('icon-heart');
                            icon.classList.add('icon-heart-filled')
                        });
                    }
                }
                break;
            case 'wishList/removeProductById':
                if (currentProductId === mutationPayload) {
                    wishListToggleButtons.forEach(button => {
                        const icon = button.querySelector('.icon');

                        icon.classList.remove('icon-heart-filled');
                        icon.classList.add('icon-heart');
                    });
                }
                break;
        }
    });

    wishListToggleButtons.forEach(button => {
        button.addEventListener('click', (() => {
            if (false === SecurityContainer.userIsLogged()) {
                HashRouter.redirect('login-modal', {type: "wishlist"});
            } else {
                const toggleProduct = async () => {
                    const productIsChecked = productInWishList(currentProductId);
                    const icon = button.querySelector('.icon');

                    icon.classList.remove('icon-heart');
                    icon.classList.remove('icon-heart-filled');
                    icon.classList.add('icon-loading');
                    icon.classList.add('icon-rotate');

                    const storeAction = productIsChecked
                        ? 'wishList/removeProductById'
                        : 'wishList/addProductById'
                    ;

                    try {
                        await store.dispatch(storeAction, currentProductId);
                    } catch (error) {
                        toast.error("Wystąpił błąd")
                    }

                    icon.classList.remove('icon-loading');
                    icon.classList.remove('icon-rotate');

                    if (productIsChecked) {
                        icon.classList.add('icon-heart');
                    } else {
                        icon.classList.add('icon-heart-filled');
                    }
                };

                toggleProduct();
            }
        }));
    })
}


function initUpSellingView() {
    const container = document.querySelector('#up-selling-view');

    if (container) {
        document.body.classList.add('show-up-selling-container');

        const closeButtons = container.querySelectorAll('.close-up-selling-container');

        for (let closeButton of closeButtons) {
            closeButton.addEventListener('click', () => {
                setTimeout(() => {
                    container.remove();

                    if (false === DefaultScreenDetector.isMobileView()) {
                        initializeStickyContent();
                    }
                }, 500)
            })
        }
    }
}

let sticky = null;

function initializeStickyContent() {
    sticky = new hcSticky('.product-gallery-content', {
        stickTo: '.product-gallery',
        top: 104,
    });
}

function destroyStickyContent() {
    if (sticky) {
        sticky.destroy();
        sticky = null;
    }
}

function initializeProducerContainer() {
    const containerSelector = '.product-producer-container';
    const nextButtonsSelector = '.description-item-link';

    const container = document.querySelector(containerSelector);
    if (!container) {
        return
    }


    const galleryCarousel = new Swiper(containerSelector  + ' .product-producer-gallery.swiper-container', {
        continuous: true,
        slidesPerView: 2.6,
        centeredSlides: true,
        breakpoints: {
            1300: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 1,
                centeredSlides: false,
            }
        },
    });

    const descriptionCarousel = new Swiper(containerSelector  + ' .product-producer-description.swiper-container', {
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    galleryCarousel.controller.control = descriptionCarousel;
    descriptionCarousel.controller.control = galleryCarousel;

    const nextButtonsAll = container.querySelectorAll(nextButtonsSelector);
    if (nextButtonsAll) {
        for (let button of nextButtonsAll) {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                if (descriptionCarousel.isEnd) {
                    galleryCarousel.slideTo(0);
                    descriptionCarousel.slideTo(0);
                } else {
                    galleryCarousel.slideNext();
                }
            })
        }
    }
}

function initializeCuttable() {
    const cuttableImageContainer = document.querySelector('#cuttable-image');
    if (cuttableImageContainer) {
        const vue = new Vue({
            components: {
                CuttableProductPreview
            }
        });
        vue.$mount(cuttableImageContainer);
    }
}

function handleSubcategoriesDesktop() {
    const subcategoryToggleMore = document.querySelector('#subcategory-desktop .subcategory-toggle-more');
    const subcategoryToggleLess = document.querySelector('#subcategory-desktop .subcategory-toggle-less');
    const subcategoryContent = document.querySelector('#subcategory-desktop .subcategory-content');

    if (!subcategoryToggleMore || !subcategoryToggleLess || !subcategoryContent) {
        return
    }

    const subcategoryItemsHeight = getComputedStyle(document.querySelector('#subcategory-desktop .subcategory-items')).getPropertyValue("height");

    if (parseInt(subcategoryItemsHeight) > 50) {
        subcategoryToggleMore.style.display = 'block';
        subcategoryToggleLess.style.display = 'none';

        subcategoryToggleMore.addEventListener('click', (event) => {
            event.preventDefault();

            subcategoryContent.classList.remove('subcategory-hidden');
            subcategoryToggleMore.style.display = 'none';
            subcategoryToggleLess.style.display = 'block';
            return false;
        });

        subcategoryToggleLess.addEventListener('click', (event) => {
            event.preventDefault();

            subcategoryContent.classList.add('subcategory-hidden');
            subcategoryToggleMore.style.display = 'block';
            subcategoryToggleLess.style.display = 'none';
            return false;
        });
    } else {
        subcategoryToggleMore.style.display = 'none';
        subcategoryToggleLess.style.display = 'none';
    }
}

const Carousels = {
    subcategoriesSlider: null,
    associationSlider: null,
    productsKitSlider: null,

    init() {
        const subcategoriesSliderSelector = '#subcategory-mobile .swiper-container';
        Carousels.subcategoriesSlider = new Swiper(subcategoriesSliderSelector, {
            slidesPerView: 'auto',
            spaceBetween: 4,
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            scrollbar: {
                el: '#subcategory-mobile .swiper-scrollbar',
                hide: false,
            },
        });

        const associationGiftSelector = '#modal-wrapper-content .swiper-container';
        Carousels.associationSlider = new Swiper(associationGiftSelector, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            preloadImages: false
        });

        const productsKitSelector = '#modal-kit-wrapper-content .swiper-container';
        Carousels.productsKitSlider = new Swiper(productsKitSelector, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            preloadImages: false
        });
    }
};

function handleSubcategoriesMobile() {
    const subcategoryToggleMore = document.querySelector('#subcategory-mobile .subcategory-toggle-more');
    const subcategoryToggleLess = document.querySelector('#subcategory-mobile .subcategory-toggle-less');
    const subcategoryWrapper = document.querySelector('#subcategory-mobile .subcategory-content .swiper-wrapper');

    if (!subcategoryToggleMore || !subcategoryToggleLess || !subcategoryWrapper) {
        return
    }

    subcategoryToggleMore.style.display = 'block';
    subcategoryToggleLess.style.display = 'none';

    const swiperScrollbar = document.querySelector('#subcategory-mobile .subcategory-content .swiper-scrollbar');

    subcategoryToggleMore.addEventListener('click', (event) => {
        event.preventDefault();

        if (swiperScrollbar) {
            swiperScrollbar.style.display = 'none';
        }

        subcategoryWrapper.classList.add('swiper-no-swiping');
        subcategoryWrapper.style.display = 'block';
        subcategoryWrapper.style.transform = 'translate3d(0, 0, 0)';
        subcategoryWrapper.style.textAlign = 'center';

        subcategoryToggleMore.style.display = 'none';
        subcategoryToggleLess.style.display = 'block';
        return false;
    });

    subcategoryToggleLess.addEventListener('click', (event) => {
        event.preventDefault();

        if (swiperScrollbar) {
            swiperScrollbar.style.display = 'block';
        }

        subcategoryWrapper.classList.remove('swiper-no-swiping');
        subcategoryWrapper.style.display = 'flex';
        subcategoryWrapper.style.transform = 'translate3d(0, 0, 0)';
        subcategoryWrapper.style.textAlign = 'left';

        subcategoryToggleMore.style.display = 'block';
        subcategoryToggleLess.style.display = 'none';
        return false;
    });
}

function validateEmail(x) {
    var filter  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (filter.test(x)) {
        return true;
    } else {
        return false;
    }
}

function initializeNotifyEmail() {
    const buttonNotifySubmit = document.querySelector('.button-notify-submit');

    if (!buttonNotifySubmit) {
        return
    }

    buttonNotifySubmit.addEventListener('click', (event) => {
        event.preventDefault();

        const client = new NotifyEmailClient();
        const modalMessage = document.querySelector('.modal-message');
        const emailElement = document.querySelector('.notify_email');
        const email = emailElement.value;
        const productId = document.querySelector('.product_id').value;

        modalMessage.style.display = '';

        if (email.length>0 && validateEmail(email) && productId>0) {

            try {
                const result = client.send(
                    email,
                    productId
                ).then((result) => {

                    modalMessage.style.display = 'none';
                    emailElement.value = '';
                    toast.success(result);

                });
            } catch (error) {
                modalMessage.style.display = 'none';
                toast.error("Błąd podczas zapisu do bazy");
            }

        } else {
            modalMessage.style.display = 'none';
            toast.error("Wpisz poprawnie adres email");
        }

        return false;
    });
}

function bindGalleryPopupHandler() {

  const bigImagesSliderId = '#big-images-slider';
  const additionalImagesSliderId = '#additional-images-slider';

  // ---------------------

  const additionalImagesSlider = document.querySelector(additionalImagesSliderId);
  if (null !== additionalImagesSlider) {
    const additionalCarousel = new Swiper(additionalImagesSliderId + ' .swiper-container', {
      slidesPerView: 4,
      spaceBetween: 10,
      centeredSlides: false,
      slideToClickedSlide: true,
      watchSlidesVisibility: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
        }
      },
      preloadImages: false
    });

    const bigImagesSlider = document.querySelector(bigImagesSliderId);
    if (null !== bigImagesSlider) {
      const bigCarousel = new Swiper(bigImagesSliderId + ' .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        preloadImages: false,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
        },
        pagination: {
          el: '.pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="dot swiper-pagination-bullet"></span>`;
          },
        },
        autoplay: false,
        autoHeight: true,
        updateOnImagesReady: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: true,
        thumbs: {
          swiper: additionalCarousel,
        }
      });
    }

  }

  // ---------------------

  const lightbox = GLightbox({
      selector: '.additional-image',
      touchNavigation: true,
      loop: true,
      preload: true,
      zoomable: true,
      svg: {
        close: '<svg width="40" height="40" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5055 8.14545L12.1509 11.5L15.5055 14.8545C15.5918 14.9409 15.6403 15.0579 15.6403 15.18C15.6403 15.3021 15.5918 15.4191 15.5055 15.5054C15.4191 15.5918 15.3021 15.6403 15.18 15.6403C15.0579 15.6403 14.9409 15.5918 14.8546 15.5054L11.5 12.1509L8.14545 15.5054C8.05914 15.5918 7.94207 15.6403 7.82 15.6403C7.69794 15.6403 7.58087 15.5918 7.49455 15.5054C7.40824 15.4191 7.35975 15.3021 7.35975 15.18C7.35975 15.0579 7.40824 14.9409 7.49455 14.8545L10.8491 11.5L7.49455 8.14545C7.40824 8.05913 7.35975 7.94207 7.35975 7.82C7.35975 7.69793 7.40824 7.58086 7.49455 7.49455C7.58087 7.40823 7.69794 7.35974 7.82 7.35974C7.94207 7.35974 8.05914 7.40823 8.14545 7.49455L11.5 10.8491L14.8546 7.49455C14.8973 7.45181 14.948 7.41791 15.0039 7.39478C15.0597 7.37165 15.1196 7.35974 15.18 7.35974C15.2404 7.35974 15.3003 7.37165 15.3561 7.39478C15.412 7.41791 15.4627 7.45181 15.5055 7.49455C15.5482 7.53729 15.5821 7.58803 15.6052 7.64387C15.6284 7.69971 15.6403 7.75956 15.6403 7.82C15.6403 7.88044 15.6284 7.94029 15.6052 7.99613C15.5821 8.05197 15.5482 8.10271 15.5055 8.14545ZM23 11.5C23 13.7745 22.3255 15.9979 21.0619 17.8891C19.7983 19.7802 18.0022 21.2542 15.9009 22.1246C13.7995 22.995 11.4872 23.2228 9.25646 22.779C7.02568 22.3353 4.97658 21.24 3.36828 19.6317C1.75997 18.0234 0.664704 15.9743 0.220974 13.7435C-0.222755 11.5128 0.00498259 9.20049 0.87539 7.09914C1.7458 4.99779 3.21978 3.20174 5.11095 1.9381C7.00211 0.674463 9.22552 0 11.5 0C14.549 0.00334834 17.4721 1.21603 19.628 3.37197C21.784 5.52791 22.9967 8.45104 23 11.5ZM22.08 11.5C22.08 9.40747 21.4595 7.36194 20.2969 5.62207C19.1344 3.88219 17.482 2.52613 15.5488 1.72535C13.6156 0.924579 11.4883 0.71506 9.43595 1.12329C7.38363 1.53152 5.49845 2.53917 4.01881 4.01881C2.53918 5.49845 1.53153 7.38362 1.1233 9.43594C0.715065 11.4883 0.924584 13.6155 1.72536 15.5488C2.52613 17.482 3.8822 19.1344 5.62207 20.2969C7.36194 21.4595 9.40748 22.08 11.5 22.08C14.3051 22.077 16.9944 20.9613 18.9778 18.9778C20.9613 16.9943 22.077 14.3051 22.08 11.5Z" fill="black"/></svg>',
        next: '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="40" height="40" rx="20" fill="#246450"/><path d="M20.417 25L25.417 20L20.417 15M24.7225 20H14.5837" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        prev: '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" version="1.1" id="svg1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><defs id="defs1" /><rect width="40" height="40" rx="20" fill="#246450" id="rect1" x="0" y="0" /><path d="m 19.5837,15 -5,5 5,5 M 15.2782,20 H 25.417" stroke="#ffffff" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" id="path1" /></svg>'
      }
  });

  EventDispatcher.$on('key:esc', () => {
      lightbox.close();
  });

  return this;
}

/**
 * @return {boolean}
 */
function hideZendeskWidget() {
    if (typeof zE == 'function') {
        if (window.zE.widget === 'messenger') {
            zE("messenger", "hide");
        } else {
            zE("webWidget", "hide");
        }
        return true;
    }
    return false;
}

function initAssociationGift() {
    const container = document.querySelector('#association-gift');
    if (!container) {
        return
    }

  const modal = document.createElement('section');
  modal.id = "modal-association-inner";
  modal.innerHTML = '<section class="cart-popup">' +
    '<span class="close-button"><i class="icon icon-close"></i></span>\n' +
    '<header>\n' +
    '   <div class="modal-name">x</div>\n' +
    '   <span class="modal-association-symbol small">y</span>\n' +
    '</header>\n' +
    '        <main id="modal-wrapper-content">\n' +
    '            <div class="swiper-container">\n' +
    '<ul class="swiper-wrapper">\n' +
    '   <li class="swiper-slide association-item">\n' +
    '      <img class="modal-association-image1" src="" width="280" height="280" alt="Zdjęcie" />\n' +
    '   </li>\n' +
    '   <li class="swiper-slide association-item">\n' +
    '      <img class="modal-association-image2" src="" width="280" height="280" alt="Zdjęcie" />\n' +
    '   </li>\n' +
    '</ul>\n' +
    '<br clear="all">\n' +
    '</div><div class="tab-header">Szczegóły produktu</div>\n' +
    '<div class="message"></div>\n' +
  '</main>\n' +
  '</section>';
  document.body.appendChild(modal);

    container.querySelectorAll('.show-association-gift').forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();

            document.querySelector("#modal-association-inner").querySelector(".modal-association-image1").src = container.getAttribute('data-product-image1');
            document.querySelector("#modal-association-inner").querySelector(".modal-association-image2").src = container.getAttribute('data-product-image2');
            document.querySelector("#modal-association-inner").querySelector(".modal-name").innerHTML = container.getAttribute('data-product-name');
            document.querySelector("#modal-association-inner").querySelector(".modal-association-symbol").innerHTML = container.getAttribute('data-product-symbol');
            document.querySelector("#modal-association-inner").querySelector(".message").innerHTML = container.getAttribute('data-product-technical-description');

            toggleShowMore(true, 'modal-association-inner');

            const mySwiper = document.querySelector('#modal-wrapper-content .swiper-container').swiper;
            mySwiper.update();

            toggleZenBox("hide");
        })
    })

    modal.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        toggleShowMore(false, 'modal-association-inner');

        toggleZenBox("show");
    })

    modal.querySelector("section.cart-popup").addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    modal.querySelector('span.close-button').addEventListener('click', () => {
        event.preventDefault();
        event.stopPropagation();

      toggleShowMore(false, 'modal-association-inner');

      toggleZenBox("show");
    })
}

 /**
  * @param {String} action
  */
function toggleZenBox(action)
{
   if (typeof zE == 'function') {
     if (window.zE.widget === 'messenger') {
       zE("messenger", action);
     } else {
       zE("webWidget", action);
     }
   }
}

 /**
  * @param {boolean} show
  * @param {String} elementName
  */
function toggleShowMore(show, elementName) {
  if (show) {
    document.querySelector("#"+elementName).classList.add("visible");
  } else {
    document.querySelector("#"+elementName).classList.remove("visible");
  }
  document.querySelector('body').style.overflowY = show ? 'hidden' : 'scroll';
}

function initProductsKit() {

  // ------------------

   const modalBox = document.createElement('section');
   modalBox.id = "modal-products-kit-inner";
   modalBox.innerHTML = '<section class="cart-popup">' +
     '<span class="close-button"><i class="icon icon-close"></i></span>' +
     '        <header>\n' +
     '            <div class="modal-name">x</div>' +
     '            <span class="modal-kit-symbol small">r</span>\n' +
     '        </header>\n' +
     '        <main id="modal-kit-wrapper-content">\n' +
     '            <div class="swiper-container">\n' +
     '                <ul class="swiper-wrapper">\n' +
     '                    <li class="swiper-slide association-item">\n' +
     '                        <img class="modal-kit-image1" src="" width="280" height="280" alt="Zdjęcie" />\n' +
     '                    </li>\n' +
     '                    <li class="swiper-slide association-item">\n' +
     '                        <img class="modal-kit-image2" src="" width="280" height="280" alt="Zdjęcie" />\n' +
     '                    </li>\n' +
     '                </ul>\n' +
     '                <br clear="all">\n' +
     '            </div><div class="tab-header">Szczegóły produktu</div>\n' +
     '            <div class="message">e</div>\n' +
     '        </main>\n' +
     '</section>'
   ;
   document.body.appendChild(modalBox);

   modalBox.addEventListener("click", (event) => {
     if (event.target.id === 'modal-products-kit-inner') {
       event.preventDefault();
       toggleShowMore(false, 'modal-products-kit-inner');
       toggleZenBox("show");
     }
   });

   modalBox.querySelector("span.close-button").addEventListener("click", (event) => {
     event.preventDefault();
     event.stopPropagation();

     toggleShowMore(false, 'modal-products-kit-inner');
     toggleZenBox("show");
   });

   // ------------------

   const modalAlkohol = document.createElement('section');
   modalAlkohol.id = "modal-alkohol-inner";
   modalAlkohol.innerHTML = '<section class="cart-popup">' +
     '<span class="close-button"><i class="icon icon-close"></i></span>' +
     '        <header>\n' +
     '            <div class="modal-name">x</div>' +
     '            <span class="modal-kit-symbol small">r</span>\n' +
     '        </header>\n' +
     '        <main id="modal-kit-wrapper-content">\n' +
     '            <div class="message"><div><br><br>\n' +
     '                    <div class="tab-header-18">Produkt dla osób pełnoletnich</div>' +
     'Produkt zawiera alkohol i jest przeznaczony wyłącznie dla osób pełnoletnich (18+).\n' +
     'Aby zrealizować zakup tego produktu, musisz być zalogowanym użytkownikiem. Zakup alkoholu wymaga rejestracji w sklepie Crazyshop.pl\n' +
     '<br>\n' +
     'Potwierdź pełnoletniość, aby kupić ten i inne produkty alkoholowe w naszym sklepie.\n' +
     '                    <br><br><br>\n' +
     '                    <label>\n' +
     '                        <input class="acceptance-alcohol-regulations" title="Akceptacja regulaminu" type="checkbox"> &nbsp; TAK, mam ukończone 18 lat i akceptuję <a href="cms.php?dzial=282,299&amp;menu=282&amp;sel=299"><u>regulamin</u></a>\n' +
     '                    </label>\n' +
     '                    <br><br>\n' +
     '<button class="button button-primary button-personalize" rel="nofollow" disabled="disabled"><span class="button-title">Dodaj do koszyka</span></button>\n' +
     '                </div></div>\n' +
     '                    <div class="footer-bottom-info">\n' +
     '                        Przedstawienie na niniejszej stronie wyrobów alkoholowych nie stanowi oferty handlowej w rozumieniu art. 66 §1 Kodeksu\n' +
     '                        Cywilnego i służy wyłącznie rezerwacji towaru zgodnie z <a href="cms.php?dzial=282,299&amp;menu=282&amp;sel=299"><u>Regulaminem</u></a>. Wyroby alkoholowe są dostępne wyłącznie\n' +
     '                        w sklepie stacjonarnym znajdującym się w Chełmnie przy ul. Łunawskiej 34, gdzie można je odebrać wyłącznie\n' +
     '                        osobiście lub za pośrednictwem kuriera, na zasadach określonych odrębnym <a href="cms.php?dzial=282,300&amp;menu=282&amp;sel=300"><u>regulaminem</u></a>.\n' +
     '                    </div>\n' +
     '        </main>\n' +
     '</section>'
   ;
   document.body.appendChild(modalAlkohol);

   modalAlkohol.addEventListener("click", (event) => {
     if (event.target.id === 'modal-alkohol-inner') {
       event.preventDefault();
       toggleShowMore(false, 'modal-alkohol-inner');
       toggleZenBox("show");
     }
   });

   modalAlkohol.querySelector("span.close-button").addEventListener("click", (event) => {
     event.preventDefault();
     event.stopPropagation();

     toggleShowMore(false, 'modal-alkohol-inner');
     toggleZenBox("show");
   });

   modalAlkohol.querySelector(".acceptance-alcohol-regulations").addEventListener("change", (event) => {
     modalAlkohol.querySelector("button.button-personalize").disabled = !modalAlkohol.querySelector(".acceptance-alcohol-regulations").checked;
   });

   // ---------------

   let product = {};

   const seeMoreProductKit = document.querySelectorAll(".products-kit");
   if (seeMoreProductKit != null) {
     seeMoreProductKit.forEach(item => {

       const productId = item.getAttribute('data-product-id');
       const productName = item.getAttribute('data-product-name');
       const productSku = item.getAttribute('data-product-symbol');
       const productBrand = item.getAttribute('data-product-brand');
       const productPrice = item.getAttribute('data-product-price');
       const productUrl = item.getAttribute('data-product-url');

       product[productSku] = {
         'id': productSku,
         'name': productName,
         'category': '',
         'brand': productBrand,
         'price': productPrice,
         'isbn': productSku,
         'position': 1
       };

       item.querySelectorAll(".show-products-kit").forEach(button => {
         button.addEventListener("click", (event) => {
           event.preventDefault();

           document.querySelector("#modal-products-kit-inner .modal-kit-image1").src = item.getAttribute('data-product-image1');
           document.querySelector("#modal-products-kit-inner .modal-kit-image2").src = item.getAttribute('data-product-image2');
           document.querySelector("#modal-products-kit-inner .modal-name").innerHTML = item.getAttribute('data-product-name');
           document.querySelector("#modal-products-kit-inner .modal-kit-symbol").innerHTML = item.getAttribute('data-product-symbol');
           document.querySelector("#modal-products-kit-inner .message").innerHTML = item.getAttribute('data-product-technical-description');

           document.querySelector("#modal-products-kit-inner").style.display = "flex";

           toggleShowMore(true, 'modal-products-kit-inner');

           const mySwiper = document.querySelector("#modal-kit-wrapper-content .swiper-container").swiper;
           mySwiper.update();

           toggleZenBox("hide");
         });
       });

       item.querySelectorAll(".confirm-button-alcohol").forEach(button => {

         button.addEventListener("click", (event) => {
           event.preventDefault();

           document.querySelector("#modal-alkohol-inner .modal-name").innerHTML = item.getAttribute('data-product-name');
           document.querySelector("#modal-alkohol-inner .modal-kit-symbol").innerHTML = item.getAttribute('data-product-symbol');
           document.querySelector("#modal-alkohol-inner").style.display = "flex";
           toggleShowMore(true, 'modal-alkohol-inner');

           document.querySelector("#modal-alkohol-inner button.button-personalize").addEventListener("click", (event) => {
             event.preventDefault();
             event.stopPropagation();

             if (modalAlkohol.querySelector(".acceptance-alcohol-regulations").checked) {
               const productId = item.getAttribute('data-product-id');
               const productName = item.getAttribute('data-product-name');
               const productSku = item.getAttribute('data-product-symbol');
               const productBrand = item.getAttribute('data-product-brand');
               const productPrice = item.getAttribute('data-product-price');
               const productUrl = item.getAttribute('data-product-url');

               product[productSku] = {
                 'id': productSku,
                 'name': productName,
                 'category': '',
                 'brand': productBrand,
                 'price': productPrice,
                 'isbn': productSku,
                 'position': 1
               };

               if (typeof ga4SendEvent == 'function') {
                 ga4SendEvent('add_to_cart', product[productSku]);
               }
               if (typeof tiktok_addToCart == 'function') {
                 tiktok_addToCart(product[productSku]);
               }
               document.location.href = 'koszyk.php?a=add&pr=' + productId + '&qty=1&return=' + item.getAttribute('data-product-return-id');
             };
           });

           toggleZenBox("hide");
         });
       });

       item.querySelectorAll('button.button-no-alcohol').forEach(kit => {

         kit.addEventListener('click', function(event) {

           if (typeof ga4SendEvent == 'function') {
             ga4SendEvent('add_to_cart', product[productSku]);
           }
           if (typeof tiktok_addToCart == 'function') {
             tiktok_addToCart(product[productSku]);
           }
           document.location.href = 'koszyk.php?a=add&pr=' + item.getAttribute('data-product-id') + '&qty=1&return=' + item.getAttribute('data-product-return-id');
         });
       });
     });
   }

 }

function initDetailsProductsHeight() {
   const container = document.querySelector("#details-products-height");
   if (!container) {
     return;
   }

   const positionInfo = container.getBoundingClientRect();

   if (positionInfo.height >= 150) {

     const tabIsOpened = container.classList.contains("limit-height");

     const containerButton = document.querySelector("#details-products-height-button");
     if (containerButton && tabIsOpened) {
       containerButton.style.display = "block";

       containerButton.addEventListener("click", () => {
         event.preventDefault();
         event.stopPropagation();

         container.classList.remove("limit-height");
         containerButton.style.display = "none";

         return false;
       });
     }
   }
}

function initSendStraight() {
   document.querySelectorAll(".table-send-straight").forEach(button => {
     button.addEventListener("click", () => {
       event.preventDefault();

       const innerText = button.querySelector("#inner-send-straight");
       if (innerText) {
         if (innerText.style.display === "none") {
           innerText.style.display = "block";
         } else {
           innerText.style.display = "none";
         }
       }

       const circle = button.querySelector("span");
       if (circle) {
         const circlePlus = circle.classList.contains('circle-arrow-button-plus');
                 circle.classList.remove('circle-arrow-button-plus');
                 circle.classList.remove('circle-arrow-button-minus');
                 if (circlePlus) {
                     circle.classList.add('circle-arrow-button-minus');
                 } else {
                     circle.classList.add('circle-arrow-button-plus');
                 }
             }
         })
     })
}

let groupSwiper = null;

function initProductVariants() {

  const toggleShowVariants = document.querySelector(".tab-header.variants");
  if (null === toggleShowVariants) {
    return;
  }

  toggleShowVariants.addEventListener("click", (event) => {
    event.preventDefault();

    toggleShowVariants.parentElement.classList.contains("hidden-section")
      ? toggleShowVariants.parentElement.classList.remove("hidden-section")
      : toggleShowVariants.parentElement.classList.add("hidden-section")
    ;

    toggleShowVariants.parentElement.querySelectorAll(".groups").forEach(item => {
      if (item.classList.contains("show-less")) {
          item.classList.remove("show-less")
          item.classList.remove("swiper-slide")
          item.classList.add("show-more")
          item.parentElement.classList.remove("swiper-wrapper");
          if (null !== groupSwiper) {
              groupSwiper.slideTo(0);
          }
      } else {
        item.classList.remove("show-more")
        item.classList.add("show-less")
        item.classList.add("swiper-slide")
        item.parentElement.classList.add("swiper-wrapper");
      }
    })
  })

    // ---

    const groupProducts = document.querySelector('.groups-slider');
    if (null !== groupProducts) {
        groupSwiper = new Swiper('.swiper-container.groups-slider', {
            slidesPerView: 6.2,
            spaceBetween: 10,
            centeredSlides: false,
            breakpoints: {
                1400: {
                    slidesPerView: 5.2,
                },
                1024: {
                    slidesPerView: 6.2,
                },
                768: {
                    slidesPerView: 5.2,
                },
                640: {
                    slidesPerView: 4.2,
                },
                412: {
                    slidesPerView: 3.2,
                }
            },
            preloadImages: false
        });
    }

}

 function initialize() {
    const alcoholBox = new AlcoholBox();
    alcoholBox.showSiteMessage();

    new CustomerFeedback();
    new DefaultProductsCarousel();
    new CartCountElement(document);

    initializeWishListToggleButton();
    initUpSellingView();
    bindGalleryPopupHandler();
    initializeProducerContainer();
    initializeCuttable();
    initializeNotifyEmail();
    initAssociationGift();
    initDetailsProductsHeight();
    initSendStraight();
    initProductsKit();
    initProductVariants();

    handleSubcategoriesDesktop();
    handleSubcategoriesMobile();

   Carousels.init();

   if (true === DefaultScreenDetector.isMobileView()) {
        let counter = 0;
        let i = setInterval(function(){
            const hidden = hideZendeskWidget();
            counter++;
            if(counter === 30 || hidden) {
                clearInterval(i);
            }
        }, 200);
    }
}

function onScroll() {
    const filtersContainer = document.querySelector('.top-filters-container');
    const horizontalDesktopMenu = document.querySelector('.horizontal-desktop-menu');
    if (!filtersContainer || !horizontalDesktopMenu) {
        return;
    }

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 100) {
        const filtersContainerStyle = getComputedStyle(filtersContainer);
        if (scrollTop > lastScrollTop) {
            filtersContainer.style.top = '-75px';
            if (filtersContainerStyle.getPropertyValue("height") === '52px') {
                filtersContainer.style.animation = 'scroll-out-filters-bar-mobile 0.4s ease-out';
            } else {
                filtersContainer.style.animation = 'scroll-out-filters-bar 0.4s ease-in';
            }
            horizontalDesktopMenu.style.top = '0';
            horizontalDesktopMenu.style.animation = 'scroll-out-menu-bar 0.4s ease-in';
        } else {
            if (filtersContainerStyle.getPropertyValue("height") === '52px') {
                filtersContainer.style.top = filtersContainerStyle.height;
                filtersContainer.style.animation = 'scroll-in-filters-bar-mobile 0.4s ease-out';
            } else {
                filtersContainer.style.top = '60px';
                filtersContainer.style.animation = 'scroll-in-filters-bar 0.4s ease-out';
            }
            horizontalDesktopMenu.style.top = '135px';
            horizontalDesktopMenu.style.animation = 'scroll-in-menu-bar 0.4s ease-out';
        }
    }
    lastScrollTop = scrollTop;
}

document.addEventListener('DOMContentLoaded', initialize);

var lastScrollTop = 0;
window.addEventListener('scroll', onScroll);

if (false === DefaultScreenDetector.isMobileView()) {
    initializeStickyContent();
}
DefaultScreenDetector.listener.onDesktopToMobileChange(() => {
    destroyStickyContent();
});
DefaultScreenDetector.listener.onMobileToDesktopChange(() => {
    initializeStickyContent();
});
